import { render, staticRenderFns } from "./HeaderOverlay.vue?vue&type=template&id=5a8a1faf&scoped=true&"
import script from "./HeaderOverlay.vue?vue&type=script&lang=js&"
export * from "./HeaderOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8a1faf",
  null
  
)

export default component.exports